"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewersListComponents = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var ViewersList_1 = require("./ViewersList");
var ViewersListFilters_1 = require("./ViewersListFilters");
function useViewersListComponents(_a) {
    var viewers = _a.viewers, noViewsComponent = _a.noViewsComponent, timeParams = _a.timeParams, openSession = _a.openSession;
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var _b = (0, ViewersListFilters_1.useViewersListFilters)(viewers), filteredViewers = _b.filteredData, filtersButton = _b.filtersButton;
    var viewersList = (react_1.default.createElement(ViewersList_1.ViewersList, { viewers: filteredViewers, onViewerCardClick: function (viewer, pageViewId) {
            openSession(viewer, pageViewId);
            serverTelemetry.sendPageAnalyticsTelemetry({
                eventName: event_tracker_types_1.EventName.PageAnalyticsSessionViewViewed,
                eventOrigin: event_tracker_types_1.EventOrigin.QwilrCard,
            });
        }, noViewsYetComponent: noViewsComponent, timeZone: timeParams.timeZone }));
    return { viewersList: viewersList, filterButtons: filtersButton };
}
exports.useViewersListComponents = useViewersListComponents;
